import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import BookmarkIcon from '@material-ui/icons/StarBorder';
import { Link, Redirect } from 'react-router-dom';
import ActionMenu from './ActionMenu';
import { delBookmark } from '../../redux/actions';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: '0.25em 0.25em 0.25em 1em',
    width: 'calc(25% - 10px)',
    color: theme.palette.text.primary,
    display: 'inline-flex',
    fontSize: '0.85em',
    margin: '0 10px 10px 0',
    boxSizing: 'border-box',
    flexWrap: 'wrap',
  },
  inner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  link: {
    width: '100%',
    textDecoration: 'none',
    color: theme.palette.text.primary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'hidden',
  },
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    width: '100%',
    marginLeft: 10,
  },
  '@media (max-width: 1200px)': {
    paper: {
      width: 'calc(33.3333% - 10px)',
    },
  },
  '@media (max-width: 900px)': {
    paper: {
      width: 'calc(50% - 10px)',
    },
  },
  '@media (max-width: 600px)': {
    paper: {
      width: '100%',
    },
  },
}));

function Bookmarks(props) {
  const classes = useStyles();
  const [redirect, setRedirect] = useState(null);
  const bookmarks = props.bookmarks[props.currentCourseId] || false;

  const Bookmark = (bookmark) => (
    <Paper key={bookmark.id} elevation={1} className={classes.paper}>
      <div className={classes.inner}>
        <Link to={bookmark.link} className={classes.link}>
          <BookmarkIcon />
          <span className={classes.title}>{bookmark.title}</span>
        </Link>
        <ActionMenu bookmark={bookmark} openBookmark={setRedirect} delBookmark={props.delBookmark} />
      </div>
    </Paper>
  );

  if (redirect) return <Redirect to={redirect} />

  return (
    <div className={classes.wrap}>
      {bookmarks && bookmarks.map(Bookmark)}
      {(!bookmarks || bookmarks.length === 0) && <div>
        <h4>Lista zakładek jest pusta.</h4>
        <p>Możesz dodawać zakładki z poziomu ćwiczeń.</p>
      </div>}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    bookmarks: state.userState.bookmarks,
    currentCourseId: state.userState.currentCourseId,
  }
}

export default connect(mapStateToProps, { delBookmark })(Bookmarks)
